<template>
  <div
    ref="linksWrapper"
    class="c-chat__mediaFilesLinks"
    :class="{ '-loading': chatAttachmentsStore.loadingMessages }">
    <div
      v-for="message in messages"
      :key="message.id"
      :class="{ '-me': isMe(message.senderDisplayName) }"
      class="c-chat__messageRow">
      <Message
        :message="message" />
    </div>
    <div
      v-if="chatAttachmentsStore.loadingMessages"
      class="o-flex -alignCenter -center">
      <LoadingSpinner />
    </div>
    <div
      v-if="!chatAttachmentsStore.loadingMessages && messages.length === 0"
      class="o-flex -alignCenter -center t-alignCenter u-colorDark">
      <div>
        <div class="t-h6 u-marginBottom1">{{ $t('chat.media_empty_title') }}</div>
        <div class="t-caption2">{{ $t('chat.media_empty_description') }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue'

import LoadingSpinner from '@/components/LoadingSpinner.vue'
import constants from '@/constants'
import { useChatAttachmentsStore } from '@/modules/chat/chatAttachmentsStore'
import { useChatStore } from '@/modules/chat/chatStore'
import Message from '@/modules/chat/components/Message.vue'

const chatStore = useChatStore()
const chatAttachmentsStore = useChatAttachmentsStore(chatStore.chatThread.azure_chat_thread_id)

const messages = ref([])
const page = ref(1)
const totalCount = ref(0)
const hasMore = ref(true)
const linksWrapper = ref(null)

const loadMessages = async () => {
  try {
    const { data, total } = await chatAttachmentsStore.getMessagesByType(constants.CHAT.MESSAGE_TYPES.LINK, page.value)
    messages.value.push(...data)
    totalCount.value = total
  } catch (e) {
    console.error('Failed to load links:', e)
  } finally {
    hasMore.value = messages.value.length < totalCount.value
  }
}

const onScroll = async (e) => {
  const t = e.target
  if (hasMore.value && !chatAttachmentsStore.loadingMessages && t.scrollHeight - t.scrollTop <= t.clientHeight + 50) {
    page.value++
    await loadMessages()
  }
}

const isMe = (userId) => {
  return chatStore.isMe(userId)
}

loadMessages()

onMounted(() => {
  linksWrapper.value.addEventListener('scroll', onScroll)
})

onBeforeUnmount(() => {
  linksWrapper.value.removeEventListener('scroll', onScroll)
})
</script>
